<template>
  <div class="virtual-phone-navbar-wrap" :style="{ height }" v-if="title">
    <div class="virtual-phone-navbar" :style="{ height, ...style }">
      <div class="left">
        <slot name="left">
          <span
            v-if="left"
            :style="{ fontSize: calc(30) }"
            :class="`iconfont icon-${left.icon}`"
            @click="exeEvent(left)"
          >
            {{ left.text || '' }}
          </span>
        </slot>
      </div>
      <div class="center" :style="{ fontSize }">
        <slot name="title">{{ title }}</slot>
      </div>
      <div class="right">
        <slot name="right">
          <span
            v-if="right"
            :style="{ fontSize: calc(30) }"
            :class="`iconfont icon-${right.icon}`"
            @click="exeEvent(right)"
          >
            {{ right.text || '' }}
          </span>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    left: {
      type: [Object, null],
      default: null
    },
    right: {
      type: [Object, null],
      default: null
    },
    backgroundColor: {
      type: String,
      default: '#0f1a2f'
    }
  },
  inject: ['calc', 'router'],
  computed: {
    style() {
      return {
        backgroundColor: this.backgroundColor,
        padding: `0 ${this.calc(29)}`
      };
    },
    fontSize() {
      return this.calc(38);
    },
    height() {
      return this.calc(82);
    }
  },
  methods: {
    exeEvent(target) {
      if (!target.click) return;
      target.click(this.router);
    }
  }
};
</script>

<style lang="scss">
.virtual-phone-navbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  background-color: #0f1a2f;
  user-select: none;
  & > * {
    flex: 1;
  }
  .center {
    text-align: center;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
  }
  .iconfont {
    font-size: 20px;
    cursor: pointer;
  }
  .right {
    text-align: right;
  }
}
</style>
